/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Kit_Example_HintInputs */

const en_simple_kit_example_hint = /** @type {(inputs: Simple_Kit_Example_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adds this wish to your idea`)
};

const id_simple_kit_example_hint = /** @type {(inputs: Simple_Kit_Example_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menambahkan permintaan ini ke idemu`)
};

/**
* | output |
* | --- |
* | "Adds this wish to your idea" |
*
* @param {Simple_Kit_Example_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_kit_example_hint = /** @type {((inputs?: Simple_Kit_Example_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Kit_Example_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_kit_example_hint(inputs)
	return en_simple_kit_example_hint(inputs)
});